import { Component, ElementRef, OnInit, computed, inject, input, output } from '@angular/core';


import { MatDialogRef, MatDialogActions, MatDialog, MatDialogModule } from '@angular/material/dialog';

import { DxButtonModule } from 'devextreme-angular';
import { ButtonType } from 'devextreme/common';

import { hasValue } from '@my-aon/utils';

const withFontAwesomeSizing = (icon: string | undefined): string | undefined =>
    hasValue(icon) && typeof icon === 'string' && /^(fa-)/.test(icon) ? `${icon} fa-fw fa-lg` : icon;

@Component({
    selector: 'app-dialog-bottom',
    templateUrl: './dialog-bottom.component.html',
    styleUrls: ['./dialog-bottom.component.scss'],
    imports: [MatDialogModule, DxButtonModule],
    host: {
        '[class]': 'ngClass()'
    }
})
export class DialogBottomComponent extends MatDialogActions implements OnInit {

    readonly dialogRef = inject<MatDialogRef<any>>(MatDialogRef);
    private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);
    readonly dialog = inject(MatDialog);

    readonly $saveText = input<string | undefined>('Save', { alias: 'saveText' });
    readonly $saveIcon = input<string | undefined>('fa-regular fa-floppy-disk', { alias: 'saveIcon' });
    readonly $saveDisabled = input<boolean | undefined>(false, { alias: 'saveDisabled' });
    readonly $saveType = input<ButtonType | undefined>('default', { alias: 'saveType' });

    readonly $cancelText = input<string | undefined>('Cancel', { alias: 'cancelText' });
    readonly $cancelIcon = input<string | undefined>('fa-regular fa-circle-xmark', { alias: 'cancelIcon' });
    readonly $cancelDisabled = input<boolean | undefined>(false, { alias: 'cancelDisabled' });
    readonly $cancelType = input<ButtonType | undefined>('normal', { alias: 'cancelType' });

    readonly onSaveClick = output<any>();
    readonly onCancelClick = output<any>();

    /** Replaces the old `onSaveClick.observed` check: outputs no longer expose a listener count. */
    readonly $showSave = input<boolean>(true, { alias: 'showSave' });

    protected readonly saveIconClass = computed<string | undefined>(() => withFontAwesomeSizing(this.$saveIcon()));

    ngClass = computed<string>(() => 'd-flex w-100 p-0 m-0 bg-light');

    override ngOnInit(): void {

        super.ngOnInit();

        (this.el.nativeElement as HTMLElement).classList.add('mat-dialog-actions');
    }

    submited: boolean = false;

    close = (e: any) => {
        this.onCancelClick.emit(e);
        this.dialogRef.close();
    }

    submit = (e: any) => {
        if (this.submited) return;

        this.submited = true;

        this.onSaveClick.emit(e);

        setTimeout(() => { this.submited = false }, 123);
    }

}
